export default () => {
    const addComparisonBtns = document.querySelectorAll(".js-add-comparison");
    const compareCounter = document.querySelector(".header__menu-link--compare .counter");
    const favoriteCounter = document.querySelector(".header__menu-link--favorite .counter");
    const body = document.querySelector("body");
    addComparisonBtns.forEach((item, i) => {
        item.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const id = this?.dataset?.id;
            const key = this?.dataset?.key;
            const action = this.classList.contains("added") ? "rm-fav" : "add-fav";
            body.classList.add("loading");
            if (id && key) {
                return fetch(`/api/v1/content/${action}/${key}/${id}`)
                    .then(
                        res => res.json()
                    )
                    .then(
                        data => {
                            let value;
                            let counter;
                            this.classList.toggle("added");
                            switch(key) {
                                case "favorite":
                                    counter = favoriteCounter;
                                    value = parseInt(counter.dataset.value);
                                    break;
                                case "compare":
                                    counter = compareCounter;
                                    value = parseInt(compareCounter.dataset.value);
                                    break;
                                default:
                                    break;
                            }
                            if (action === "rm-fav") {
                                value -= 1;
                                if (value <= 0) {
                                    value = 0;
                                }
                                if (this.dataset.hasOwnProperty("remove") && this.dataset.hasOwnProperty("removeSelector")) {
                                    const removeEl = this.closest(this.dataset.removeSelector);
                                    let parent = false;
                                    if (removeEl.classList.contains("swiper-slide")) {
                                        parent = removeEl.closest(".swiper-container");
                                    }
                                    removeEl.remove();
                                    if (parent) parent.swiper.update();
                                }
                            }
                            else if (action === "add-fav") {
                                value += 1;
                            }
                            counter.dataset.value = value;
                            if (document.querySelector(".comparison .filters__counter span")) {
                                document.querySelector(".comparison .filters__counter span").innerText = value;
                            }
                            value > 0 ? counter.parentElement.classList.add("counter") : counter.parentElement.classList.remove("counter");
                            if (value === 0 && document.querySelector(`[data-type="${key}"]`)) {
                                document.querySelector(`[data-type="${key}"]`).classList.add("comparison--empty");
                            }
                            body.classList.remove("loading");
                        }
                    )
                    .catch(
                        error => {
                            body.classList.remove("loading");
                            console.log(error);
                        }
                    );
            }
        });
    });
};
